module.exports = __webpack_public_path__ + "img/4-2-1-5-5-preview-Korean-colourbook-2-e.e54fc7e0.jpg";